import React from 'react';
import Header from './Header';
import services from '../json/services.json';
import mobile from '../svgs/mobile.svg';
import code from '../svgs/code.svg';
import gamepad from '../svgs/gamepad.svg';
import keyboard from '../svgs/keyboard.svg';
import palette from '../svgs/palette.svg';


function Services() {
	const icons = [code, mobile, gamepad, palette, keyboard];
	return (
		<React.Fragment>
			<Header appTitle="Services" />
			<div className="main-body services-page pd-md-v xl-pd-none">
				<div>
					{services.map((service, index) => {
						return (
							<div key={service.title} className="each-data flex align-center flex-column md-no-column justify-center bg-light sp-xl-bottom ln">
								<div className="banner flex align-center justify-center bg-fixed">
									<img className="sp-lg-h" src={icons[index]} alt="icon" />
								</div>
								<div className="flex flex-column flex-grow justify-center pd-md">
									<h2 className="txt-primary sp-bottom">{service.title}</h2>
									<p className="">{service.description}</p>
								</div>
							</div>
						);
					})}
				</div>
				<div className="sp-xl-h blob-t blob-b pd-md-h txt-fade">
					<i>Do you have any other job that is not listed above and is releated to the field of programming? Feel free to contact me for any connection that you need. I have build a strong network of developers in different fields including Machine Learning (ML), Artifficial Intelligence (AI), Data Science and many more.</i>
				</div>
			</div>
		</React.Fragment>
	);
}

export default Services;
